<template>
    <div>
        <div id="filter-chips-list-title" class="lead mb-0">
            <strong v-html="title" />
        </div>
        <span
            data-ob1-component="Chips"
            role="group"
            class="ob1-filterchip d-flex align-items-start flex-column d-lg-block"
            aria-labelledby="filter-chips-list-title"
        >
            <template v-for="(chips, index) in chipsList">
                <ob1-chips-button-element
                    :key="index"
                    class="mb-1 me-lg-2"
                    :label="chips.label"
                    :aria-controls="linkedWithResults ? 'total-mobiles' : null"
                    :is-active="chips.checked"
                    @ob1-chips-click="clickHandler(chips.id, $event)"
                />
            </template>
        </span>
        <ob1-message-alerte
            v-if="inlineAlert"
            type="info"
            :title="inlineAlert"
        />
        <hr class="separator separator--gray4">
    </div>
</template>

<script>
export default {
    name: "IntentionSwitch",
    props: {
        shopSosh: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        inlineAlert: {
            type: String,
            default: null
        },
        defaultIntentionChecked: {
            type: String,
            required: false,
            default: undefined
        },
        acquisitionLabel: {
            type: String,
            required: false,
            default: undefined
        },
        tseulLabel: {
            type: String,
            required: false,
            default: undefined
        },
        changerDeMobileLabel: {
            type: String,
            required: false,
            default: undefined
        },
        linkedWithResults: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    computed: {
        chipsList() {
            let chipsList = [];
            if (this.shopSosh) {
                if (this.acquisitionLabel) {
                    chipsList.push(
                        {
                            id: "intention-acquisition",
                            label: this.acquisitionLabel,
                            checked: this.defaultIntentionChecked === 'acquisition',
                        }
                    )
                }
                if (this.changerDeMobileLabel) {
                    chipsList.push(
                        {
                            id: "intention-changer-de-mobile",
                            label: this.changerDeMobileLabel,
                            checked: this.defaultIntentionChecked === 'renouvellement',
                        }
                    )
                }
            } else {
                if (this.changerDeMobileLabel) {
                    chipsList.push(
                        {
                            id: "intention-changer-de-mobile",
                            label: this.changerDeMobileLabel,
                            checked: ['pcm', 'renouvellement'].includes(this.defaultIntentionChecked)

                        }
                    )
                }
                if (this.tseulLabel) {
                    chipsList.push(
                        {
                            id: "intention-tseul",
                            label: this.tseulLabel,
                            checked: this.defaultIntentionChecked === 'terminal-seul',

                        }
                    )
                }
                if (this.acquisitionLabel) {
                    chipsList.push(
                        {
                            id: "intention-acquisition",
                            label: this.acquisitionLabel,
                            checked: this.defaultIntentionChecked === 'acquisition',
                        }
                    )
                }
            }
            return chipsList;
        }
    },
    methods: {
        clickHandler(selectedId, event) {
            event.stopPropagation()
            this.$emit('switch-intention', selectedId)
        }
    }
}
</script>
